import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const rolesApi = createApi({
    reducerPath: 'rolesApi',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://onza-api.ibm.kg/api/common/',
        prepareHeaders: (headers, { getState }) => {
            let { auth: { auth } } = getState();
            if (typeof auth == "string") {
                auth = JSON.parse(auth);
            }
            headers.set("Authorization", `Bearer ${auth?.accessToken}`);
            return headers;
        },
    }),
    tagTypes: ["Roles"],
    endpoints: (builder) => ({
        getRoles: builder.query({
            query: () => `roles`,
            providesTags: ["Roles"],
        }),
        addRoles: builder.mutation({
            query: (newRoles) => ({
                url: 'roles',
                method: 'POST',
                body: newRoles,
            }),
            invalidatesTags: ['Roles'],
        }),
        deleteRoles: builder.mutation({
            query: ({ id }) => ({
                url: `roles/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Roles'],
        }),
    }),
})

export const { useGetRolesQuery, useAddRolesMutation, useDeleteRolesMutation } = rolesApi